import * as React from "react";

const CreatePackage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    className="svg-icon"
    overflow="hidden"
    style={{ width: "11em", height: "11em", verticalAlign: "middle" }}
    viewBox="0 0 1024 1024"
  >
    <path
      d="M442.88 206.933a64 64 0 0 1 57.557-3.114l6.016 3.029 218.667 124.97a64 64 0 0 1 31.957 49.366l.299 6.187v88.576a21.333 21.333 0 0 1-42.325 3.84l-.342-3.84v-88.534a21.33 21.33 0 0 0-7.68-16.341l-3.072-2.133-218.666-125.014a21.33 21.33 0 0 0-17.792-1.536l-3.414 1.579-218.624 124.928a21.33 21.33 0 0 0-10.41 14.763l-.384 3.754v249.174a21.33 21.33 0 0 0 7.68 16.341l3.072 2.133 218.666 125.014a21.33 21.33 0 0 0 17.792 1.536l3.414-1.579 91.008-52.01a21.333 21.333 0 0 1 24.32 34.858l-3.158 2.176-91.05 52.053a64 64 0 0 1-57.472 2.987l-6.016-2.987-218.667-124.97a64 64 0 0 1-31.957-49.366l-.299-6.186V387.413c0-20.864 10.155-40.277 27.008-52.224l5.248-3.328 218.624-124.97z"
    ></path>
    <path
      d="M713.216 353.579a21.333 21.333 0 0 1 22.827 35.84l-3.243 2.048-226.048 116.736c-17.877 9.258-38.741 10.282-57.344 3.157l-6.827-3.072-227.37-116.779a21.333 21.333 0 0 1 15.914-39.381l3.584 1.408L462.08 470.315c6.57 3.413 14.165 3.925 21.077 1.706l4.054-1.706zM264.106 491.52a21.33 21.33 0 0 1 25.686-9.43l3.499 1.622 124.416 71.808a21.333 21.333 0 0 1-17.835 38.57l-3.499-1.62-124.458-71.851a21.333 21.333 0 0 1-7.808-29.142z"
    ></path>
    <path
      d="M474.71 479.445a21.33 21.33 0 0 1 20.949 17.536l.341 3.84-.683 303.403a21.333 21.333 0 0 1-42.325 3.755l-.341-3.84.682-303.403a21.333 21.333 0 0 1 21.376-21.333zM816 645.333a21.333 21.333 0 0 1 3.84 42.326L816 688H592a21.333 21.333 0 0 1-3.84-42.325l3.84-.342z"
    ></path>
    <path
      d="M704 533.333a21.33 21.33 0 0 1 20.992 17.494l.341 3.84v224a21.333 21.333 0 0 1-42.325 3.84l-.341-3.84v-224A21.333 21.333 0 0 1 704 533.333"
    ></path>
  </svg>
);

export default CreatePackage;
